export interface Project {
  id?: number;
  name?: string;
  description?: string;

  cost_center_id?: number | null;
  surface?: number | null;
  planted_varieties?: string | null;

  planted_quantity?: number | null;
  greenhouses_count?: number | null;
  workers_count?: number | null;

  total_area?: number | null;
  occupied_area?: number | null;
  idle_area?: number | null;
  corridors_count?: number | null;

  costs?: number | null;
  sales?: number | null;

  status?: string | '';
  status_label?: string;

  is_active?: boolean;

  planted_variety_ids?: number[];
  user_ids?: number[];
}

export type ProjectDataForm = Project;

/** Campos numéricos opcionales: enviar null en lugar de '' para que el backend no falle validación (cost_center_id es obligatorio) */
const OPTIONAL_NUMERIC_KEYS: (keyof ProjectDataForm)[] = [
  'surface', 'planted_quantity', 'greenhouses_count', 'workers_count',
  'total_area', 'occupied_area', 'idle_area', 'corridors_count', 'costs', 'sales'
];

export function normalizeProjectPayloadForApi(project: ProjectDataForm): ProjectDataForm {
  const out = { ...project };
  for (const key of OPTIONAL_NUMERIC_KEYS) {
    const v = out[key];
    if (v === '' || v === undefined) {
      (out as any)[key] = null;
    }
  }
  if (out.planted_variety_ids === undefined) {
    out.planted_variety_ids = [];
  }
  if (out.user_ids === undefined) {
    out.user_ids = [];
  }
  return out;
}

export interface ProjectFilters {
  id?: number | null;
  code?: string | '';
  name?: string | '';
  description?: string | '';
  start_date?: string | '';
  end_date?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export interface Product {
  id: number;
  name: string;
}

export interface ProjectUserOption {
  id: number;
  name: string;
}
